import React, { useEffect } from 'react'
import { useIntl } from 'react-intl';
import { PLACEHOLDER_MESSAGES_STEP1 } from '../../constants';
import CustomSelect from 'utils/components/CustomSelect';
import { getSectorValues } from './constants';
import { useFormikContext } from 'formik';

const SectorSelect = ({ name, updateField }) => {
  const intl = useIntl();
  const { values: { sector } } = useFormikContext();

  return (
    <CustomSelect
      config={{
        name,
        initialValue: sector && getSectorValues(intl).find(({ id }) => id === sector)?.label,
        placeholderMessage: intl.formatMessage(PLACEHOLDER_MESSAGES_STEP1["sector"]),
        disabled: false,
        disabledPlaceholder: "",
      }}
      selectValues={getSectorValues(intl)}
      updateField={updateField}
      returnValue="id"
    />
  );
}

export default SectorSelect;